// extracted by mini-css-extract-plugin
export default {"label":"RadioButton_label__LO9oC","input":"RadioButton_input__If2Y7"};